'use client';

import {
  documentToReactComponents,
  Options,
} from '@contentful/rich-text-react-renderer';
import { BLOCKS, Document, INLINES, MARKS } from '@contentful/rich-text-types';
import {
  renderBlockEmbeddedAsset,
  renderBlockH1,
  renderBlockH2,
  renderBlockH3,
  renderBlockHr,
  renderBlockListItem,
  renderBlockOrderedList,
  renderBlockQuote,
  renderBlockUnorderedList,
  renderBoldMark,
  renderInlineHyperLink,
  renderItalicMark,
  renderText,
  renderUnderlineMark,
} from 'components/RichTextRender/helpers/renderers';
import { useParams } from 'next/navigation';
import { FC, useMemo } from 'react';

export interface RichTextRenderProps {
  content: Document;
}

const getOptions = (store: Store, language: Language): Options => ({
  renderMark: {
    [MARKS.BOLD]: renderBoldMark,
    [MARKS.ITALIC]: renderItalicMark,
    [MARKS.UNDERLINE]: renderUnderlineMark,
  },
  renderNode: {
    [INLINES.HYPERLINK]: renderInlineHyperLink(store, language),
    [BLOCKS.HEADING_1]: renderBlockH1,
    [BLOCKS.HEADING_2]: renderBlockH2,
    [BLOCKS.HEADING_3]: renderBlockH3,
    [BLOCKS.QUOTE]: renderBlockQuote,
    [BLOCKS.LIST_ITEM]: renderBlockListItem,
    [BLOCKS.OL_LIST]: renderBlockOrderedList,
    [BLOCKS.UL_LIST]: renderBlockUnorderedList,
    [BLOCKS.HR]: renderBlockHr,
    [BLOCKS.EMBEDDED_ASSET]: renderBlockEmbeddedAsset,
  },
  renderText,
});

const RichTextRender: FC<RichTextRenderProps> = ({ content }) => {
  const { store, language } = useParams<{ store: Store; language: Language }>();

  const options = useMemo(() => getOptions(store, language), [store, language]);

  return <>{documentToReactComponents(content as Document, options)}</>;
};

export default RichTextRender;
